/**
 * Stage → what a reader should understand by it.
 *
 * `stage` is the last pipeline step the harness observed, so a finished run used
 * to read "report" forever: the truthful name of the step it stopped on, and
 * indistinguishable from a sweep stalled while writing its report. The harness
 * now writes three terminal values of its own (`complete`, `no_targets`,
 * `dependency_unavailable`); this map turns every value into a phrase rather than
 * a tool name.
 *
 * Unknown values fall through verbatim at the call site. `stage` is free text and
 * the harness may grow steps faster than this map, and the raw token is more use
 * than "Unknown".
 *
 * Its own module rather than a second export from `RunHeader`, because two things
 * read it now — the run header renders it, and the Wiki tab documents it. The
 * Wiki has to document the vocabulary the UI actually renders; a copy over there
 * would drift the first time the harness grew a step.
 */
export const STAGE_LABELS: Record<string, string> = {
  generate: 'Generating hypotheses',
  review: 'Reviewing hypotheses',
  tournament: 'Running the tournament',
  meta_review: 'Meta-review',
  report: 'Writing the report',
  complete: 'Analysis complete',
  // Not a failure and not a success: the sweep ran and nothing survived review.
  // The status badge is `empty`; this says which way.
  no_targets: 'Complete — no targets ranked',
  // Same "no targets" outcome, opposite cause: a data source the sweep depends on
  // stopped answering, so the search never happened. The status badge is `blocked`.
  dependency_unavailable: 'Stopped — a data source was unavailable',
}
